import { useEffect } from "react";
import { Sidebar } from "../../common/AppSidebar";
import { useStorageObject } from "../../app/state/storageObjectSlice/hook/use-storage-object";
import { useServiceNavigate } from "../../app/state/storageObjectSlice/hook/use-service-navigate";
import { AddNewBotModal } from "../../features/Chatbot/Components/AppNewBotDialog";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";
import { useAppDispatch } from "../../services/redux/hooks/use-dispatch";
import { botMigrationToStorageObjectAction } from "../../features/Chatbot/redux/actions";
import { SafeOutlet } from "../../common/Protectors/SafeOutlet";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import styles from "./styles.module.css";

export const ChatbotPage = () => {
  const dispatch = useAppDispatch();
  const { menuItems, selectedObject, isLoading, currentService } =
    useStorageSelectors("ai_agents_telegram_bots");
  const { handleSelectObject } = useStorageObject(
    "ai_agents_telegram_bots",
    "ai_agents_telegram_bots",
    currentService,
  );
  const { handleCloseModal, handleOpenModal } = useAppModals();

  useEffect(() => {
    dispatch(botMigrationToStorageObjectAction());
  }, []);

  useServiceNavigate("ai_agents_telegram_bots", "ai_agents_telegram_bots");

  return (
    <div className={styles["page-layout"]}>
      <Sidebar
        menuItems={menuItems}
        onAdd={() =>
          handleOpenModal("add_new_bot_modal", null, "add_from_sidebar")
        }
        onSelect={handleSelectObject}
        selectedId={selectedObject?.id ?? ""}
        service={"ai_agents_telegram_bots"}
        isLoading={isLoading ?? false}
      />
      {selectedObject && <SafeOutlet />}
      <AddNewBotModal
        addBotModalType={"add_from_sidebar"}
        closeModal={handleCloseModal}
      />
    </div>
  );
};
